import {BankOption, PurchaseItem} from "@/store/shop/types";

export class ChainDto {

    elements!: BankOption[];
    title!: string;
    agitation!: string;
    currentIndex!: number;
}

export enum ChainState {
    TIZER = 'TIZER',
    IN_PROGRESS = 'IN_PROGRESS',
    TAKE_REWARD = 'TAKE_REWARD',
    CONGRATULATION = 'CONGRATULATION',
    COMPLETED = 'COMPLETED'
}

export class Chain {
    id!: number;
    chainId!: string;
    expiresAt!: number;
    chainState!: ChainState;
}

export class TaskOption extends BankOption {
    atlasId!: string;
    countCurr!: number;
    countTotal!: number;
}
